export const EnrolledStatuses = {
  ELECTED: 'elected',
  PRE_MEMBER_FUTURE_EFFECTIVE_DATE: 'pre-member future effective date',
  PRE_MEMBER_CURRENT_MONTH: 'pre-member current month',
  ENROLLED_FUTURE_EFFECTIVE_DATE: 'enrolled future effective date',
  ENROLLED: 'enrolled',
  CANCELED: 'canceled',
  DELINQUENT: 'enrolled-delinquent',
  SUSPENDED: 'suspended',
  TERMED: 'termed',
  TERMED_FUTURE: 'termed future effective date',
}
